import { render } from "./AddNewVisitModal.vue?vue&type=template&id=712bba16"
import script from "./AddNewVisitModal.vue?vue&type=script&lang=js"
export * from "./AddNewVisitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__